import * as Yup from 'yup'

export const userFormValidationSchema = Yup.object({
  name: Yup.string()
    .min(2, 'Enter a name more than 1 characters long')
    .required('This field is required'),
  username: Yup.string()
    .min(2, 'Enter a name more than 1 characters long')
    .required('This field is required'),
  email: Yup.string()
    .email('Enter a valid email address')
    .min(6, 'Enter an email address more than 6 characters long')
    .required('This field is required'),
  password: Yup.string()
    .min(6, 'Use 6 characters or more for your password')
    .max(20, 'Enter a password less than 20 characters long')
    .matches(
      /^(?=(?:[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]){2})(?=.{6,20}$).*$/,
      'Enter a password containing 6 to 20 characters and at least two special characters'
    ),
  phoneNumber: Yup.string()
    .matches(/^(?:\+98|98|0)?9\d{9}$/, 'Enter a valid Iranian mobile number')
    .required('This field is required'),

  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Passwords must match'
  ),
  regionalSettings: Yup.object().shape({
    languagesAvailable: Yup.array()
      .of(Yup.string())
      .min(1, 'Select at least one language')
      .required('This field is required'),
    currenciesAvailable: Yup.array()
      .of(Yup.string())
      .min(1, 'Select at least one currency')
      .required('This field is required'),
    defaultCurrency: Yup.string().required('This field is required'),
    timezone: Yup.string().required('This field is required')
  }),
  roleID: Yup.string().required('This field is required')
  // EntityId: Yup.string().when('Role', {
  //   is: (Role: UserRole) => Role !== 'ADMIN',
  //   then: Yup.string().required('This field is required')
  // })
})
